window.zapietCustom = () => {
    setTimeout(() => {
        let deliveryRadio = document.querySelector("#delivery_radio input[type='radio']");
        let pickupRadio = document.querySelector("#pickup_radio input[type='radio']");

        if (deliveryRadio && pickupRadio) {
            deliveryRadio.addEventListener("change", () => {
                deliveryRadio.closest("label").classList.add("active");
                pickupRadio.closest("label").classList.remove("active");
            });

            pickupRadio.addEventListener("change", () => {
                pickupRadio.closest("label").classList.add("active");
                deliveryRadio.closest("label").classList.remove("active");
            });

            // Initialize the active class based on the checked radio button on page load
            if (deliveryRadio.checked) {
                deliveryRadio.closest("label").classList.add("active");
                pickupRadio.closest("label").classList.remove("active");
            } else if (pickupRadio.checked) {
                pickupRadio.closest("label").classList.add("active");
                deliveryRadio.closest("label").classList.remove("active");
            }
        }   
    }, 1000);
}

document.addEventListener("DOMContentLoaded", () => {
    window.zapietCustom();
});